<div class="not-found-wrapper">
  <h1 class="not-found-wrapper__title">404</h1>
  <p class="not-found-wrapper__desc">{{ 'general.label.404' | translate }}</p>
</div>
